/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes, { string } from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  Dialog,
  Button,
  Dropdown,
  TextInput,
  CustomCheckBox,
  Image,
  Anchor,
} from "hesus-ui-kit";
import PulseLoader from "react-spinners/PulseLoader";
import ClipLoader from "react-spinners/ClipLoader";
import { useGetGeneralParameters } from "@hooks/useGeneralParams";
import CKEditorText from "@components/CKEditorText/CKEditorText";
import { loadSingleContact } from "../ContactList/ContactList.actionCreators";
import {
  setSingleContactLoadingState,
  updateContact,
} from "../ContactList/ContactList.slice";
import errorIcon from "@icons/ic-error.svg";
import Company from "./components/Company/Company";
import ContactView from "../ContactView/ContactView";
import closeIcon from "@icons/ic-close-white.svg";
import { CONTACT_LIST_ENDPOINT, contactTypeText } from "@utils/constants";
import {
  labelStyles,
  inputStyles,
  labelStylesError,
  inputStylesError,
  SuccessMessage,
} from "@utils/extra-style";
import {
  HeaderWrapper,
  Title,
  ButtonWrapper,
  FlexEndButtonWrapper,
  FlexStartButtonWrapper,
  FormBody,
  OptionsWrapper,
  FlexRow,
  SectionContainer,
  GridRow,
  ContainerLabel,
  RequiredMessage,
  ErrorDiv,
} from "./AddEditContact.styled";

const AddEditContact = (props) => {
  const {
    t,
    id,
    isEditMode,
    isViewMode,
    title,
    onClose,
    togglePopUp,
    updateRefeshStatus,
    page,
    companyId,
    isViewContact,
    contactData,
    setIsContactValidated,
    leadId,
    countryId,
  } = props;

  const dataURL = CONTACT_LIST_ENDPOINT;
  const dispatch = useDispatch();
  const generalParams = useGetGeneralParameters();

  const [isContactCreating, setIsContactCreating] = useState(false);
  const [updatedContactId, setUpdatedContactId] = useState("");
  const [userCreated, setUserCreated] = useState(false);
  const [isUserCreating, setIsUserCreating] = useState(false);
  const [createUserAPIError, setCreateUserAPIError] = useState(false);
  const [createUserAPISuccess, setCreateUserAPISuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isAddEditConatct, setIsAddEditConatct] = useState(true);
  const [isViewConatct, setIsViewConatct] = useState(false);
  const [createContactAPIError, setCreateContactAPIError] = useState("");
  const [contactExistInfo, setContactExistInfo] = useState([]);
  const contactListByIds = useSelector((state) => state.contactList.byId);
  const selectedContact = contactData ?? contactListByIds[id];
  const [descriptionData, setDescriptionData] = useState(
    selectedContact?.comment ?? ""
  );

  const existingContact = useSelector(
    (state) => state.contactList.selectedContact
  );
  const contactOperationalTypeList = generalParams.contactOperationalType;
  
  const [checkedRoles, setCheckedRoles] = useState([]);

  const [formData, setFormData] = useState({
    courtesy: {
      required: true,
      value: (selectedContact?.courtesy === "MISTER" ? 2 : 1) ?? "",
      error: "",
    },
    firstName: {
      required: true,
      value: selectedContact?.firstName ?? "",
      error: "",
    },
    lastName: {
      required: true,
      value: selectedContact?.lastName ?? "",
      error: "",
    },
    job: {
      required: true,
      value: selectedContact?.job ?? "",
      error: "",
    },
    email: {
      required: true,
      value: selectedContact?.email ?? "",
      error: "",
    },
    phone: {
      required: true,
      value: selectedContact?.phone ?? "",
      error: "",
    },
    mobile: {
      required: true,
      value: selectedContact?.mobilePhone ?? "",
      error: "",
    },
    description: {
      required: false,
      value: selectedContact?.comment ?? "",
      error: "",
    },
    roles: {
      required: false,
      value: selectedContact?.roles ?? [],
      error: "",
    },
    company: {
      required: true,
      value: selectedContact?.company ?? "",
      error: "",
    },
  });

  useEffect(() => {
    setFormData({
      ...formData,
      description: {
        value: descriptionData,
        error: "",
        required: true,
      },
    });
  }, [descriptionData]);

  const onCourtesyChange = (e) => {
    setFormData({
      ...formData,
      courtesy: {
        value: e.value,
        error: "",
        required: true,
      },
    });
  };
  const onFirstNameChange = (e) => {
    setFormData({
      ...formData,
      firstName: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };
  const onLastNameChange = (e) => {
    setFormData({
      ...formData,
      lastName: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };
  const OnJobChange = (e) => {
    setFormData({
      ...formData,
      job: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };
  const OnEmailChange = (e) => {
    setFormData({
      ...formData,
      email: {
        value: e.target.value,
        error: "",
        required: true,
      },
      mobile: {
        ...formData.mobile,
        error: "",
      },
      phone: {
        ...formData.phone,
        error: "",
      },
    });
    setContactExistInfo([]);
  };

  const OnPhoneChange = (e) => {
    setFormData({
      ...formData,
      phone: {
        value: e.target.value,
        error: "",
        required: true,
      },
      email: {
        ...formData.email,
        error: "",
      },
      mobile: {
        ...formData.mobile,
        error: "",
      },
    });
  };

  const OnMobileChange = (e) => {
    setFormData({
      ...formData,
      mobile: {
        value: e.target.value,
        error: "",
        required: true,
      },
      email: {
        ...formData.email,
        error: "",
      },
      phone: {
        ...formData.phone,
        error: "",
      },
    });
  };

  const onRoleChange = (e, checkedRoleId) => {
    const jobValue = e.target.checked;
    if (!jobValue) {
      const checkedRolesInitial = [];
      for (let i = 0; i < checkedRoles.length; i++) {
        if (checkedRoleId !== checkedRoles[i]) {
          checkedRolesInitial.push(checkedRoles[i]);
        }
      }
      setCheckedRoles(checkedRolesInitial);
    } else {
      setCheckedRoles((checkedRoles) => [...checkedRoles, checkedRoleId]);
    }
  };

  useEffect(() => {
    if (isEditMode) {
      const checkedRolesInitial = [];
      if (formData.roles.value.length > 0) {
        formData.roles.value.map((data) => {
          checkedRolesInitial.push(parseInt(data.roleId, 10));
        });
        setCheckedRoles(checkedRolesInitial);
      }
    }
  }, [isEditMode]);

  const fetchRecords = (contactId) => {
    // Set the loading state
    dispatch(setSingleContactLoadingState());
    dispatch(
      loadSingleContact({
        dataURL,
        contactId,
      })
    );
  };

  async function checkEmailExist(email) {
    const response = await axios.get(
      `/general/search?email=${email}&limit=5&countries=[${countryId}]&objectTypes=["contact"]`
    );
    return response.data;
  }

  const validateForm = (data) => {
    let isFormValid = true;
    if (!data.firstName.value) {
      isFormValid = false;
      data.firstName.error = t("FIRST_NAME_REQUIRED");
    }
    if (!data.lastName.value) {
      isFormValid = false;
      data.lastName.error = t("LAST_NAME_REQUIRED");
    }
    if (!data.company?.value?.id) {
      isFormValid = false;
      data.company.error = t("COMPANY_REQUIRED");
    }
    if (!data.job.value) {
      isFormValid = false;
      data.job.error = t("JOB_REQUIRED");
    }
    if (!data.email.value && !data.phone.value && !data.mobile.value) {
      isFormValid = false;
      data.email.error = t("EMAIL_REQUIRED");
      data.phone.error = t("PHONE_REQUIRED");
      data.mobile.error = t("MOBILE_REQUIRED");
    }
    if (
      data.email.value &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.email.value)
    ) {
      isFormValid = false;
      data.email.error = "INVALID_EMAIL_FORMAT";
    }
    if (data.phone.value && !/^[0-9+]{8,14}$/i.test(data.phone.value)) {
      isFormValid = false;
      data.phone.error = t("INVALID_PHONE_FORMAT");
    }
    if (data.mobile.value && !/^[0-9+]{8,14}$/i.test(data.mobile.value)) {
      isFormValid = false;
      data.mobile.error = t("INVALID_MOBILE_FORMAT");
    }
    if (!isFormValid) {
      setFormData({ ...data });
    }
    return isFormValid;
  };

  const getFormData = () => {
    let rolesData = [];
    for (let i = 0; i < checkedRoles.length; i++) {
      rolesData.push({
        roleId: checkedRoles[i],
        roleLabel: contactTypeText[checkedRoles[i]],
      });
    }
    const data = {
      id: isEditMode ? selectedContact.id : "",
      courtesy: formData.courtesy.value,
      firstName: formData.firstName.value,
      lastName: formData.lastName.value,
      company: formData.company.value,
      roles: rolesData,
      email: formData.email.value,
      job: formData.job.value,
      phone: formData.phone.value,
      mobile: formData.mobile.value,
      comment: formData.description.value,
      status: 1,
      createdAt: "",
      updatedAt: "",
    };
    if (leadId) {
      data.leadId = leadId;
    }
    return data;
  };
  const onSubmit = () => {
    const isFormValid = validateForm(formData);
    if (isFormValid) {
      checkEmailExist(formData.email.value).then((response) => {
        if (
          response?.contacts.length === 0 ||
          (isEditMode &&
            response?.contacts.length === 1 &&
            response?.contacts[0].id === id) ||
          !formData.email.value
        ) {
          setIsContactCreating(true);
          setCreateContactAPIError("");
          // Create solution
          if (!id && !isEditMode) {
            axios
              .post("/contacts", getFormData())
              .then(() => {
                setIsContactCreating(false);
                if (page === "contact") {
                  updateRefeshStatus();
                }
                onClose();
              })
              .catch((error) => {
                setIsContactCreating(false);
                setCreateContactAPIError(error.response?.data?.message ?? "");
              });
          }
          // Edit
          if (id && isEditMode) {
            axios
              .put(`/contacts/${id}`, getFormData())
              .then(() => {
                setIsContactCreating(false);
                if (page === "contact") {
                  updateRefeshStatus();
                }
                if (page === "lead") {
                  setIsContactValidated(true);
                  onClose();
                }
              })
              .catch((error) => {
                setIsContactCreating(false);
                setCreateContactAPIError(error.response?.data?.message ?? "");
              });
          }
        } else {
          let matchedContactInfo = response?.contacts[0];
          if (id && isEditMode) {
            matchedContactInfo = response?.contacts.filter(
              (contact) => contact.id !== id
            );
            matchedContactInfo = matchedContactInfo[0];
          }
          setContactExistInfo(matchedContactInfo);
          formData.email.error = "CONTACT_ERROR_EMAIL_USED";
          setFormData({ ...formData });
          fetchRecords(matchedContactInfo.id);
        }
      });
    }
  };

  const onEdit = () => {
    togglePopUp();
  };

  const openViewPopUp = () => {
    setIsViewConatct(true);
    setIsAddEditConatct(false);
  };

  const toogleViewPopUp = () => {
    setIsViewConatct(false);
    setIsAddEditConatct(true);
  };

  useEffect(() => {
    if (page === "viewContact") {
      setIsAddEditConatct(false);
      setIsLoading(true);
    }
    if (page === "viewContact" && existingContact) {
      setIsViewConatct(true);
      setIsLoading(false);
    }
  }, [page, existingContact]);

  const createUser = (id, email) => {
    const formData = {
      contactId: id,
      email: email,
    };
    setIsUserCreating(true);
    setUpdatedContactId(id);
    setCreateUserAPIError("");
    setCreateUserAPISuccess("");
    axios
      .post("/general/users", formData)
      .then(() => {
        setCreateUserAPISuccess("CLIENT_USER_CREATED_SUCCESS");
        setUserCreated(true);
        setIsUserCreating(false);
        setTimeout(() => {
          setCreateUserAPISuccess("");
        }, 5000);
      })
      .catch((error) => {
        setIsUserCreating(false);
        setCreateUserAPIError(error.response?.data?.message ?? "");
        setTimeout(() => {
          setCreateUserAPIError("");
        }, 5000);
      });
  };

  const closePopUP = () => {
    if (updatedContactId !== "") {
      dispatch(updateContact({ id: updatedContactId, status: true }));
      setUpdatedContactId("");
    }
    onClose();
  };

  return (
    <Dialog>
      <div>
        <HeaderWrapper>
          <Title>
            {isViewConatct ? t("CONTACT") + " #" + existingContact?.id : title}
          </Title>
          <Button
            onClick={closePopUP}
            styles={{
              backgroundColor: "transparent",
              border: "none",
              height: "auto",
              padding: 0,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Image
              src={closeIcon}
              alt="close meeting report popup"
              styles={{ width: "auto" }}
            />
          </Button>
        </HeaderWrapper>
        {isLoading && (
          <div className="suggestions-list-loading">
            <PulseLoader color="#1bace4" size={15} />
          </div>
        )}
        {isViewConatct && <ContactView contactInfo={existingContact} />}
        {isViewMode && !isViewContact && (
          <ContactView contactInfo={selectedContact} />
        )}
        {isViewContact && isViewContact && (
          <ContactView contactInfo={contactData} />
        )}

        {!isViewMode && isAddEditConatct && (
          <FormBody>
            <OptionsWrapper>
              <FlexRow>
                <SectionContainer>
                  <div>
                    <GridRow column="1fr 1fr 1fr">
                      <Dropdown
                        id="contact-courtesy"
                        label={t("COURTESY")}
                        name="courtesy"
                        value={formData.courtesy.value}
                        onChange={onCourtesyChange}
                        defaultOption={t("COURTESY")}
                        options={[
                          {
                            label: t("CONTACT_COURTESY_MISS"),
                            value: 1,
                          },
                          {
                            label: t("CONTACT_COURTESY_MISTER"),
                            value: 2,
                          },
                        ]}
                        labelStyles={{ fontWeight: "bold" }}
                        containerStyles={{ marginBottom: "1.32rem" }}
                        inputStyles={{ border: "1px solid #474747" }}
                      />

                      <TextInput
                        id="contact-firstname"
                        type="text"
                        label={t("CONTACT_FIRSTNAME")}
                        isFloat
                        value={String(formData.firstName.value)}
                        onChange={(e) => onFirstNameChange(e)}
                        containerStyles={{ marginTop: "21px" }}
                        errorStyles={{ "font-style": "italic" }}
                        labelStyles={
                          formData.firstName.error !== ""
                            ? labelStylesError
                            : labelStyles
                        }
                        inputStyles={
                          formData.firstName.error !== ""
                            ? inputStylesError
                            : inputStyles
                        }
                        required
                        // disabled={isDisabled}
                        error={formData.firstName.error}
                        placeholder={t("CONTACT_FIRSTNAME")}
                      />
                      <TextInput
                        id="contact-lastname"
                        type="text"
                        label={t("CONTACT_LASTNAME")}
                        isFloat
                        value={String(formData.lastName.value)}
                        onChange={(e) => onLastNameChange(e)}
                        containerStyles={{ marginTop: "21px" }}
                        errorStyles={{ "font-style": "italic" }}
                        labelStyles={
                          formData.lastName.error !== ""
                            ? labelStylesError
                            : labelStyles
                        }
                        inputStyles={
                          formData.lastName.error !== ""
                            ? inputStylesError
                            : inputStyles
                        }
                        required
                        // disabled={isDisabled}
                        error={formData.lastName.error}
                        placeholder={t("CONTACT_LASTNAME")}
                      />
                    </GridRow>
                    <GridRow column="1fr 1fr">
                      <div>
                        <Company
                          formData={formData}
                          setFormData={setFormData}
                          isEditMode={isEditMode}
                          selectedContact={selectedContact}
                          objectId={companyId}
                          countryId={countryId}
                        />
                      </div>
                      <TextInput
                        type="text"
                        id="contact-job"
                        isFloat
                        value={String(formData.job.value)}
                        label={t("CONTACT_FUNCTION")}
                        containerStyles={{ marginTop: "21px" }}
                        errorStyles={{ "font-style": "italic" }}
                        labelStyles={
                          formData.job.error !== ""
                            ? labelStylesError
                            : labelStyles
                        }
                        inputStyles={
                          formData.job.error !== ""
                            ? inputStylesError
                            : inputStyles
                        }
                        required
                        onChange={(e) => OnJobChange(e)}
                        error={formData.job.error}
                        placeholder={t("CONTACT_FUNCTION")}
                      />
                    </GridRow>
                    <GridRow column="1fr">
                      <ContainerLabel>{t("CONTACT_TYPE")}</ContainerLabel>
                    </GridRow>
                    <GridRow column="1fr 1fr 1fr 1fr 1fr">
                      {contactOperationalTypeList?.map((contactType) => (
                        <CustomCheckBox
                          key={"contact_" + contactType.value}
                          id={contactType.value}
                          labelText={t(contactType.label)}
                          dataId={contactType.value}
                          onChange={(e) => {
                            onRoleChange(e, parseInt(contactType.value, 10));
                          }}
                          checked={
                            checkedRoles.indexOf(contactType.value) !== -1
                          }
                        />
                      ))}
                    </GridRow>
                    <GridRow column="1fr 1fr">
                      <TextInput
                        type="text"
                        id="contact-email"
                        isFloat
                        value={String(formData.email.value)}
                        label={t("CONTACT_EMAIL")}
                        containerStyles={{ marginTop: "21px" }}
                        errorStyles={{ "font-style": "italic" }}
                        labelStyles={
                          formData.email.error !== ""
                            ? labelStylesError
                            : labelStyles
                        }
                        inputStyles={
                          formData.email.error !== ""
                            ? inputStylesError
                            : inputStyles
                        }
                        required
                        onChange={(e) => OnEmailChange(e)}
                        placeholder={t("CONTACT_EMAIL")}
                        error={
                          formData.email.error === "INVALID_EMAIL_FORMAT"
                            ? t("INVALID_EMAIL_FORMAT")
                            : ""
                        }
                      />
                      <TextInput
                        type="text"
                        id="contact-phone"
                        isFloat
                        label={t("CONTACT_PHONE")}
                        value={String(formData.phone.value)}
                        containerStyles={{ marginTop: "21px" }}
                        errorStyles={{ "font-style": "italic" }}
                        labelStyles={
                          formData.phone.error !== ""
                            ? labelStylesError
                            : labelStyles
                        }
                        inputStyles={
                          formData.phone.error !== ""
                            ? inputStylesError
                            : inputStyles
                        }
                        required
                        onChange={(e) => OnPhoneChange(e)}
                        placeholder={t("CONTACT_PHONE")}
                      />
                    </GridRow>
                    <GridRow column="1fr 1fr">
                      <div></div>
                      <TextInput
                        type="text"
                        isFloat
                        id="contact-mobile"
                        label={t("CONTACT_MOBILE")}
                        value={String(formData.mobile.value)}
                        containerStyles={{ marginTop: "21px" }}
                        errorStyles={{ "font-style": "italic" }}
                        labelStyles={
                          formData.mobile.error !== ""
                            ? labelStylesError
                            : labelStyles
                        }
                        inputStyles={
                          formData.mobile.error !== ""
                            ? inputStylesError
                            : inputStyles
                        }
                        required
                        onChange={(e) => OnMobileChange(e)}
                        placeholder={t("CONTACT_MOBILE")}
                      />
                    </GridRow>
                    {formData.email.error !== "" &&
                      formData.mobile.error !== "" &&
                      formData.phone.error !== "" && (
                        <GridRow column="1fr">
                          <ErrorDiv>
                            <RequiredMessage>
                              <Image
                                src={errorIcon}
                                alt="warning"
                                styles={{ width: "18px" }}
                              />{" "}
                              {t("CONTACT_ERROR_COMMUNICATION_FIELDS") +
                                " " +
                                t("CONTACT_EMAIL") +
                                ", " +
                                t("CONTACT_PHONE") +
                                ", " +
                                t("CONTACT_PHONE")}
                            </RequiredMessage>
                          </ErrorDiv>
                        </GridRow>
                      )}

                    {formData.email.error !== "" &&
                      formData.email.error === "CONTACT_ERROR_EMAIL_USED" && (
                        <GridRow column="1fr">
                          <ErrorDiv>
                            <RequiredMessage>
                              <Image
                                src={errorIcon}
                                alt="warning"
                                styles={{ width: "18px" }}
                              />{" "}
                              {t("CONTACT_ERROR_EMAIL_USED")}{" "}
                              <Anchor
                                clickAction={openViewPopUp}
                                styles={{
                                  textDecoration: "underline !important",
                                }}
                              >
                                {contactExistInfo.id +
                                  " - " +
                                  contactExistInfo.name}
                              </Anchor>
                            </RequiredMessage>
                          </ErrorDiv>
                        </GridRow>
                      )}

                    <GridRow column="1fr">
                      <div>
                        <ContainerLabel htmlFor="description">
                          {t("DESCRIPTION")}
                        </ContainerLabel>
                        <CKEditorText
                          descriptionData={descriptionData}
                          setDescriptionData={setDescriptionData}
                        />
                        {formData.description.error && (
                          <RequiredMessage>
                            {formData.description.error}
                          </RequiredMessage>
                        )}
                      </div>
                    </GridRow>
                  </div>
                </SectionContainer>
              </FlexRow>
            </OptionsWrapper>
          </FormBody>
        )}
        <ButtonWrapper>
          <FlexStartButtonWrapper>
            {createUserAPISuccess && (
              <SuccessMessage>{t(createUserAPISuccess)}</SuccessMessage>
            )}
            {createUserAPIError && (
              <RequiredMessage margin="5px 0">
                {t(createUserAPIError)}
              </RequiredMessage>
            )}
            {isViewMode &&
              !isViewContact &&
              !selectedContact?.isPlatfrom &&
              selectedContact?.email !== "" &&
              !userCreated && (
                <Button
                  styles={{
                    color: "#0A4986",
                    background: "#fff",
                    border: "2px solid #0A4986",
                    marginRight: "0.32rem",
                    "&:hover": {
                      backgroundColor: "#fff",
                    },
                  }}
                  onClick={() =>
                    createUser(selectedContact.id, selectedContact.email)
                  }
                >
                  {isUserCreating && <ClipLoader size={15} color="#0A4986" />}
                  {!isUserCreating && t("ACTION_CREATE_CLIENT_USER")}
                </Button>
              )}
          </FlexStartButtonWrapper>
          <FlexEndButtonWrapper>
            {createContactAPIError && <div>{createContactAPIError}</div>}
            <Button
              styles={{
                color: "#333",
                background: "#fff",
                border: "1px solid #ccc",
                marginRight: "0.32rem",
                "&:hover": {
                  backgroundColor: "#ccc",
                },
              }}
              onClick={closePopUP}
            >
              <>
                {page === "relatedContact" && t("BACK")}
                {page === "contact" && t("CLOSE")}
                {page === "viewContact" && t("CLOSE")}
                {page === "lead" && t("CLOSE")}
              </>
            </Button>
            {isViewConatct && page !== "viewContact" && (
              <Button
                styles={{
                  color: "white",
                  background: "#1BACE4",
                  border: "1px solid #1BACE4",
                  marginRight: "0.32rem",
                  "&:hover": {
                    backgroundColor: "#1589b6",
                  },
                }}
                onClick={toogleViewPopUp}
              >
                <>
                  {isContactCreating && <ClipLoader size={15} color="#fff" />}
                  {!isContactCreating && t("BACK")}
                </>
              </Button>
            )}
            {!isViewMode && !isViewConatct && (
              <Button
                styles={{
                  color: "white",
                  background: "#1BACE4",
                  border: "1px solid #1BACE4",
                  marginRight: "0.32rem",
                  "&:hover": {
                    backgroundColor: "#1589b6",
                  },
                }}
                onClick={onSubmit}
              >
                <>
                  {isContactCreating && <ClipLoader size={15} color="#fff" />}
                  {!isContactCreating && t("SUBMIT")}
                </>
              </Button>
            )}
            {isViewMode && !isViewContact && (
              <Button
                styles={{
                  color: "white",
                  background: "#1BACE4",
                  border: "1px solid #1BACE4",
                  marginRight: "0.32rem",
                  "&:hover": {
                    backgroundColor: "#1589b6",
                  },
                }}
                onClick={onEdit}
              >
                {t("EDIT")}
              </Button>
            )}
          </FlexEndButtonWrapper>
        </ButtonWrapper>
      </div>
    </Dialog>
  );
};

AddEditContact.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
  title: PropTypes.string.isRequired,
  isEditMode: PropTypes.bool,
  isViewMode: PropTypes.bool,
  page: PropTypes.string,
  companyId: PropTypes.number,
  isViewContact: PropTypes.bool,
  setIsContactValidated: PropTypes.bool,
  leadId: PropTypes.number,
  countryId: PropTypes.number,
};

AddEditContact.defaultProps = {
  id: null,
  isEditMode: false,
  isViewMode: false,
  page: "contact",
  companyId: null,
  isViewContact: false,
  setIsContactValidated: null,
  leadId: null,
  countryId: null,
};
export default withTranslation()(AddEditContact);
